import React, { useState } from 'react';

interface MessengerChatProps {
  pageId?: string;
}

const MessengerChat: React.FC<MessengerChatProps> = ({ 
  pageId = '529866840201071',
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const openMessenger = () => {
    const messengerUrl = `https://m.me/${pageId}`;
    window.open(messengerUrl, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-40">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-3 animate-fade-in">
          <div className="bg-gray-900 text-white text-sm px-3 py-2 rounded-lg shadow-lg whitespace-nowrap">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              <span>Chat with us</span>
            </div>
            <div className="absolute top-full right-5 w-0 h-0 border-l-[5px] border-r-[5px] border-t-[5px] border-transparent border-t-gray-900" />
          </div>
        </div>
      )}

      {/* Chat Button */}
      <button
        onClick={openMessenger}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="relative w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 active:scale-95 border border-gray-200 flex items-center justify-center group"
        aria-label="Chat on Messenger"
      >
        {/* Messenger Icon */}
        <svg className="w-6 h-6 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.908 1.434 5.503 3.678 7.199V22l3.378-1.874c.9.252 1.855.388 2.944.388 5.523 0 10-4.145 10-9.243S17.523 2 12 2zm.994 12.468l-2.547-2.72-4.97 2.72 5.467-5.803 2.61 2.72 4.907-2.72-5.467 5.803z"/>
        </svg>

        {/* Online dot */}
        <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 bg-green-500 rounded-full border-2 border-white" />
      </button>
    </div>
  );
};

export default MessengerChat;
